export const confirmationBlockOpen = {
	init: function(blockContainer) {
		if (!blockContainer) return;
		[].slice.call(blockContainer).forEach(function(addressBlock) {
			this.deletBtn = addressBlock.querySelector('.jsRemoveBtn');
			this.cancelBtn = addressBlock.querySelector('.cancel-button');
			this.warningBlock = addressBlock.querySelector('.confirmation-wrapper');
			this.assignEventListeners(this.deletBtn, this.cancelBtn, this.warningBlock);
		}.bind(this));
	},

	assignEventListeners: function(deletBtn, cancelBtn, warningBlock) {
		deletBtn.addEventListener('click', e=> {
			e.preventDefault();
			warningBlock.classList.toggle('confirmation-wrapper--open');
		});

		cancelBtn.addEventListener('click', e=> {
			e.preventDefault();
			warningBlock.classList.remove('confirmation-wrapper--open');
		});
	}
}
